import styled from 'styled-components'

export const StyledPrivateLayout = styled.div`
    height: 100%;
    display: grid;
    grid-template-rows: auto 1fr;
    overflow: hidden;
`
